import { StateCreator } from 'zustand';
import { Store } from 'src/stores/store.interface';
import { logger } from 'src/utils/logger';
import { callSNOWDataService } from 'src/utils/snowDataServiceWrapper';
import { TaskTypeListStore } from './taskTypeListStore.interface';
import {
	SDS_APIGATEWAY_ENDPOINT,
	SNOW_NXT_WORKFLOW_ENDPOINT,
} from 'src/config';
import { getApiErrorMessage } from 'src/utils/CommonUtils';
import {
	convertOperationsIntoTaskSchema,
	convertSubWorkflowsIntoTaskSchema,
} from 'src/stores/taskTypeListStore/taskTypeListStoreUtils';
import { getAwsCredentials, getJwtToken } from 'src/authentication/cognito';
import AWS from 'aws-sdk';

export const defaultTaskTypeListStore = {
	isTaskTypeListLoading: false,
	taskTypeList: [],
	subWorkflowList: [],
	taskTypeListError: '',
};

const taskTypeListStore: StateCreator<Store, [], [], TaskTypeListStore> = (
	set
) => ({
	...defaultTaskTypeListStore,
	setTaskTypeList: () =>
		set((state) => ({ isTaskTypeListLoading: state.isTaskTypeListLoading })),
	fetchTaskTypeList: async (domains, entityType, parentWorkflowId) => {
		try {
			set({ isTaskTypeListLoading: true });

			await getAwsCredentials();
			const credentials = {
				accessKey: AWS.config.credentials?.accessKeyId,
				secretKey: AWS.config.credentials?.secretAccessKey,
				sessionToken: AWS.config.credentials?.sessionToken,
			};

			const jwtToken = await getJwtToken();

			const [apiResponseForExistingTasksList, apiResponseForOperations] =
				await Promise.all([
					callSNOWDataService({
						path: `/tasks/${domains.toString()}`,
						method: 'GET',
						url: SNOW_NXT_WORKFLOW_ENDPOINT,
						headers: {
							'x-jwt-token': jwtToken,
						},
						credentials,
						...(entityType && { queryParams: { entityType } }),
						// eslint-disable-next-line @typescript-eslint/no-explicit-any
					} as any),
					callSNOWDataService({
						path: '/operation/listOperations/',
						method: 'GET',
						url: SDS_APIGATEWAY_ENDPOINT,
						headers: {
							'x-jwt-token': jwtToken,
						},
						credentials,
						queryParams: {
							status: 'ACTIVE',
							count: 100,
						},
						// eslint-disable-next-line @typescript-eslint/no-explicit-any
					} as any),
				]);

			const operations = convertOperationsIntoTaskSchema(
				apiResponseForOperations.operations
			);

			const combinedTaskList = [
				...apiResponseForExistingTasksList.supportedTasks,
				...operations,
			];

			const subWorkflowList = convertSubWorkflowsIntoTaskSchema(
				apiResponseForExistingTasksList.supportedSubWorkflows,
				parentWorkflowId
			);

			set({
				isTaskTypeListLoading: false,
				taskTypeList: combinedTaskList,
				subWorkflowList,
			});
			logger.info(
				`Response from get domains [ domains : supportedTasks ] ::: [ ${domains} : ${JSON.stringify(
					combinedTaskList
				)} ]`
			);
		} catch (error) {
			logger.error(
				`Exception occured while calling task type list api for request [ id : Error ] ::: [ ${domains} : ${JSON.stringify(
					error
				)} ]`
			);
			set({
				isTaskTypeListLoading: false,
				taskTypeListError: getApiErrorMessage(error),
			});
		}
	},
});

export default taskTypeListStore;
